// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"ae14a4280681477bbe54","993":"a45afbfa61c13f1ef8ff"}[chunkId] + ".js");